export const shortcuts = {
  projectsPopup: {
    shortcut: 'ctrl+p+o',
    label: 'Панель с проектами',
  },
  shortcuts: {
    shortcut: 'ctrl+s+h',
    label: 'Просмотр горячих клавиш',
  },
  paletteCommand: {
    shortcut: 'ctrl+t+o',
    label: 'Настройки темы',
  },
}
